import { BrutalistBadge } from "@/app/components/brand-scaffold";
import { Button } from "@/app/components/ui/button";
import { badgeSamples, buttonSamples } from "@/design-system/registry/playground-atoms";

export function PlaygroundAtomsSection() {
  return (
    <div>
      <div className="border-l-8 border-black pl-4 mb-10">
        <p className="text-xs font-black uppercase tracking-widest text-zinc-400 mb-1">SECTION B</p>
        <h2 className="text-3xl font-black uppercase">原子级控件</h2>
      </div>

      <div className="flex flex-col gap-16">
        <div>
          <h3 className="text-2xl font-black uppercase mb-6 border-b-4 border-black pb-2 inline-block">【B.1】BRUTALISTBADGE — 独立粗野徽章</h3>
          <p className="font-bold text-zinc-500 mb-6">活跃在排版缝隙间的点缀元素，可带色彩跳变与抬升动效。</p>
          <div className="flex flex-wrap gap-6 items-center p-8 border-4 border-dashed border-black/20 bg-white/50">
            {badgeSamples.map((b) => (
              <BrutalistBadge
                key={b.id}
                bgClass={b.bgClass}
                hoverBgClass={b.hoverBgClass}
                hoverTextClass={b.hoverTextClass}
                className="hover:-translate-x-1 hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_rgba(0,0,0,1)]"
              >
                【{b.id}】{b.label}
              </BrutalistBadge>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-black uppercase mb-6 border-b-4 border-black pb-2 inline-block">【B.2】BUTTON — 核心交互按钮</h3>
          <p className="font-bold text-zinc-500 mb-6">最重要的动作转化组件，拥有全套物理悬停抬升与受压沉降反馈。</p>
          <div className="flex flex-wrap gap-6 items-center p-8 border-4 border-dashed border-black/20 bg-white/50">
            {buttonSamples.map((b) => (
              <Button key={b.id} variant={b.variant}>【{b.id}】{b.label}</Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
